import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

// @mui/material components

import CircularProgress from '@mui/material/CircularProgress';

// @mui/icons-material
import Face from "@mui/icons-material/Face";
import Assignment from "@mui/icons-material/Ballot";
import Dns from "@mui/icons-material/Dns";
import SettingsRemote from "@mui/icons-material/SettingsRemote";
import Visibility from "@mui/icons-material/Visibility";
import Activacion from "@mui/icons-material/TouchApp";
import Close from "@mui/icons-material/Close";
import Email from "@mui/icons-material/Email";
import Payment from "@mui/icons-material/Payment";
import Key from "@mui/icons-material/Key";
import DoorOpen from "@mui/icons-material/DoorFront";
import Add from "@mui/icons-material/Add";

// core components
import Grid from "@mui/material/Grid";

import OthelloBotonera from '../componentsothello/OthelloBotonera.jsx';
import { DataStatePage, OpcionSiNoChar, RolesUsuarios, ModoAreasPoi, ModoAreaPoi, TipoOthelloFieldGrid, PopUpResult, Roles, DataStateModal, MessageOthelloBoxButtons, DialogOthelloResult, ModoModal, EstadoReserva, EstadosReserva, ResultadoReserva, FiltroVerReservas, OpcionSiNo, OpcionSiNoEntero, OpcionVisibilidadReservas, ModoReport } from "../othelloConstantes.jsx";
import { EstaCancelarDisponibleReserva, EstaCheckoutDisponibleReserva } from "../othelloFunciones.jsx";
import OthelloGrid from '../componentsothello/OthelloGrid.jsx';
import OthelloEdit from '../componentsothello/OthelloEdit.jsx';
import OthelloTimer from '../componentsothello/OthelloTimer.jsx';
import OthelloComboBox from '../componentsothello/OthelloComboBox.jsx';

import NavPills from "../components/NavPills.jsx";
import Button from "../components/Button.jsx";
import ImageUpload from "../components/ImageUpload.jsx";
import OthelloPopUpResult from "../componentsothello/OthelloPopUpResult.jsx";
import OthelloModalBase from '../componentsothello/OthelloModalBase.jsx';
import OthelloMensaje from '../componentsothello/OthelloMensaje.jsx';

import OthelloTitulo from '../componentsothello/OthelloTitulo.jsx';

import { ImprimirListado } from '../othelloFunciones.jsx';


import Divider from "@mui/material/Divider";

import Reservar from './Reservar.js';
import Card from "@mui/material/Card";
import OthelloTituloPanelData from "../componentsothello/OthelloTituloPanelData.jsx";
import ReservarAmpliar from "./ReservarAmpliar.js";

import TicketReservaInfo from "./TicketReservaInfo.jsx";

export default function Perfil({ ...props }) {
    const { literal, idRol, tipooficina, loginmodoreserva, loginapps, idUser } = props;

    const { search } = useLocation();

    const [loading, setLoading] = React.useState(true);
    const [loadingOficinas, setloadingOficinas] = React.useState(true);
    const [loadingArchivos, setloadingArchivos] = React.useState(true);
    const [loadingAccesosAreasPois, setloadingAccesosAreasPois] = React.useState(true);
    const [loadingRservas, setloadingRservas] = React.useState(true);

    const [id_usuario, setid_usuario] = React.useState(0);
    const [statePageOficina, setstatePageOficina] = React.useState(DataStatePage.dsSearch);
    const [statePageArchivos, setstatePageArchivos] = React.useState(DataStatePage.dsSearch);

    const [datausuario, setdatausuario] = React.useState(null);
    const [dataoficinas, setdataoficinas] = React.useState(null);
    const [dataAccesosAreasPois, setdataAccesosAreasPois] = React.useState([]);
    const [dataArchivos, setdataArchivos] = React.useState([]);
    const [dataReservas, setdataReservas] = React.useState([]);
    const [stateModal, setstateModal] = React.useState(DataStateModal.dsClosed);
    const [itemmodal, setitemmodal] = React.useState(null);
    const [modomodal, setmodomodal] = React.useState(null);

    const [oficinas, setoficinas] = React.useState([]);
    const [areas, setareas] = React.useState([]);
    const [pois, setpois] = React.useState([]);

    const [filtroreserva, setfiltroreserva] = React.useState(0);
    const [filtrofranja, setfiltrofranja] = React.useState(0);

    const [filtroestado, setfiltroestado] = React.useState(EstadoReserva.Confirmada);

    const [dataeditandoOficina, setdataeditandoOficina] = useState(null);
    const [indexeditandoOficina, setindexeditandoOficina] = useState(null);

    const [dataeditandoArchivo, setdataeditandoArchivo] = useState(null);
    const [indexeditandoArchivo, setindexeditandoArchivo] = useState(null);

    const [alert, setalert] = React.useState(null);
    const [erroralert, seterroralert] = React.useState(null);

    const [stateModalEliminar, setstateModalEliminar] = React.useState(null);
    const [stateModalCheckOut, setstateModalCheckOut] = React.useState(null);
    const [stateModalAmpliar, setstateModalAmpliar] = React.useState(null);    

    React.useEffect(() => {

        let url = search;

        let params = new URLSearchParams(url);
        let idselected = params.get('id');

        if (idselected == null || idselected == 0)
            idselected = idUser;

        let SuperUsuario = idRol == Roles.SuperUsuario || idRol == Roles.Administrador;
       
        let finalvisua = SuperUsuario ? 0 : "1";
        let finalfranja =  0
        let finalestado = EstadoReserva.Confirmada;        

        getDataPage(idselected);
        getDataPageOficinas();
        getDataPageArchivos();
        getDataPageReservas(idselected, finalvisua, finalfranja, finalestado);

    }, [loading]);

    //METODOS GLOBALES DE LA PAGINA

    //Metodo asociados al Usuario

    const getDataPage = (idselected) => {

        var jsonData = JSON.stringify(idselected);

        fetch('api/Data/GetUsuario', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res => {
            setdatausuario(res);
            setid_usuario(res.id_Usuario);
            setLoading(false);
        }).catch(error => {
            setdatausuario(null);
            setid_usuario(0);            
        });
    }

    const getDataVacia = () => {

        fetch('api/Data/GetUsuarioVacio')
            .then(response => response.json())
            .then(data => {
                setdatausuario(data);
                setid_usuario(data.id_Usuario);               
            }).catch(error => {
                setdatausuario(null);
                setid_usuario(0);                
            });;
    }

    const grabarDataPage = (event) => {

        //Obtengo los datos
        let formulario = document.getElementById('formusuario');
        let formData = new FormData(formulario);

        fetch('api/Data/GrabarUsuario', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(data => {
            if (data != null) {

                if (data.id_Usuario > 0) {
                    setdatausuario(data);
                    setid_usuario(data.id_Usuario);
                    setalert(PopUpResult.OK);                   
                }
                //no se grabo, pass -- repetir pass
                else
                    setalert(PopUpResult.KO);
            }
            else
                setalert(PopUpResult.KO);
        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }

    const actualizarCodigoCliente = (event) => {
        //Obtengo los datos
        let formulario = document.getElementById('formactivacion');
        let formData = new FormData(formulario);
        //const data = new FormData(refs.form);

        fetch('api/Data/ActualizaCodigoClienteUsuario', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {

            setalert(PopUpResult.OK);

        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }

    const grabarPassDataPage = (event) => {

        //Obtengo los datos
        let formulario = document.getElementById('formusuario');
        let formData = new FormData(formulario);

        fetch('api/Data/GuardarNuevaPass', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(data => {
            if (data != null && data)
                setalert(PopUpResult.OK);
            else
                setalert(PopUpResult.KO);
        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }

    const deshacerDataPage = () => {
        
        getDataPage(id_usuario);
    }

    const onClosePopUpResult = () => {
        setalert(null);
        seterroralert(null);
    }

    const othelloModalResul = (modo, result, valor) =>
    {
        setalert(null);
        seterroralert(null);
        setstateModal(DataStateModal.dsClosed);
        setitemmodal(null);
        setmodomodal(null);
    }

    const OnResultReserva = (res, retorno) => {
        let error = "";

        if (res != PopUpResult.OK) {
            if (retorno == ResultadoReserva.OK || retorno == ResultadoReserva.OkAFaltaDePago)
                error = "";
            else if (retorno == ResultadoReserva.SinDisponibilidad)
                error = "No hay disponibilidad para los parametros indicados, disculpe las molestias";
            else if (retorno == ResultadoReserva.UsuarioMaxTramosDia)
                error = "No puede realizar mas reservas para dicho dia en la instalacion indicada";
            else
                error = retorno;

            setalert(res);
            seterroralert(error);
        }
        else {
            setalert(res);
            seterroralert(error);
            setdataReservas(null);
        }
    }

    const onclickColumna = (valor, field) => {

        if (field == "btruta") {
            if (valor != null && valor.ruta != null && valor.ruta != '') {
                window.open(valor.ruta, '_blank');
            }
        }
        else if (field == "ver") {
            setstateModal(DataStateModal.dsOpen);
            setitemmodal(valor);
            setmodomodal(field);
        }      
        else if (field == "pagar")
            actualizarPagadaConfirmadadReserva(valor);
        else if (field == "email")
            EnviarMailReserva(valor);
        else if (field == "conectacerradura")
            ActualizarAsociarReservaACerradura(valor);
        else if (field == "delete") {
            if (EstaCancelarDisponibleReserva(valor, valor.tipoInstalacion))
                setstateModalEliminar(valor);
            else {
                setalert(PopUpResult.KO);
                seterroralert("No se puede eliminar la reserva debido a su estado actual");
            }

        }
        else if (field == "checkout") {
            if (EstaCheckoutDisponibleReserva(valor, valor.tipoInstalacion, valor.conCheckOutHoraria))
                setstateModalCheckOut(valor);
            else {
                setalert(PopUpResult.KO);
                seterroralert("No se puede realizar el checkout a la reserva  debido a su estado actual");
            }
        }
        else if (field == "ampliar") {
            if (EstaCheckoutDisponibleReserva(valor, valor.tipoInstalacion, 1))
                setstateModalAmpliar(valor);
            else {
                setalert(PopUpResult.KO);
                seterroralert("No se puede realizar ampliaciones a la reserva actual");
            }
        }
    }

    //Metodo asociados a los acceso a oficinas del usuario

    const getDataPageOficinas = () => {

        fetch('api/Data/GetOficinasVirtual')
            .then(response => response.json())
            .then(data => {

                let resoficinas = data.map(x => {
                    let val =
                    {
                        ...x,
                        valor: x.id_Oficina,
                        name: x.nombreOficina
                    };

                    return val;

                })

                setoficinas(resoficinas);
            });


        var jsonData = JSON.stringify(id_usuario);

        fetch('api/Data/GetAccesoOficinas', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res => {
            setdataoficinas(res);
            setloadingOficinas(false);
        }).catch(error =>
        {
            setdataoficinas(null);
            setloadingOficinas(true);            
        });
    }

    const getDataVaciaOficina =() => {

        var jsonData = JSON.stringify(datausuario.id_Usuario);

        fetch('api/Data/GetAccesoOficinaVacio', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(data =>
        {
            setdataeditandoOficina(data);
            
            setstatePageOficina(DataStatePage.dsInsert);
            setdataAccesosAreasPois([]);
            setloadingAccesosAreasPois(true);
            setareas([]);
            setpois([]);
            
        }).catch(error => {
            setdataeditandoOficina(null);
        });
    }

    const grabarDataPageOficina = (event) => {

        //Altero el valor que tiene el input de dias visualizando
        try {
            if (oficinas != null && indexeditandoOficina == -1) {
               // var item = oficinas.find(x => x.id_Oficina == refs.form[3].value);

                //if (item != null)
                 //   refs.form[2].value = item.nombreOficina;
            }
        }
        catch { }

        //Obtengo los datos
        //const data = new FormData(refs.form);
        let formulario = document.getElementById('formaccesoficina');
        let formData = new FormData(formulario);


        fetch('api/Data/GrabaAccesoOficina', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {

            if (res != null) {
                if (oficinas != null) {
                    var item = oficinas.find(x => x.id_Oficina == res.id_Oficina);

                    if (item != null)
                        res.nomOficina = item.nombreOficina;
                }

                if (indexeditandoOficina == -1) {

                    var array = [...dataoficinas];
                    array.push(res);
                    setdataoficinas(array);
                }
                else {
                    var array = [...dataoficinas];
                    array[indexeditandoOficina] = res;
                    setdataoficinas(array);
                }

                setdataeditandoOficina(null);
                setindexeditandoOficina(null);
                setstatePageOficina(DataStatePage.dsSearch);
            }

        }).catch(error => {
            //setState({ submitted: true, error: 2 });
        });
    }

    const nuevoDataPageOficina = () => {
        //LLama a obtener el idioma vacio, que es el que pondra el estado
        getDataVaciaOficina();
        setindexeditandoOficina(-1);
    }

    const cancelarDataPageOficina = () => {
        setdataeditandoOficina(null);
        setindexeditandoOficina(null);
        setstatePageOficina(DataStatePage.dsSearch);
        setdataAccesosAreasPois([]);
        setloadingAccesosAreasPois(true);
        setareas([]);
        setpois([]);
    }

    const deshacerDataPageOficina = () =>
    {
        //Si el que estabamos editando era uno nuevo al deshacer nos vamos a la de buqueda
        if (indexeditandoOficina == -1)
            setstatePageOficina(DataStatePage.dsSearch);
        //Sino, es que estabamos en un item valido
        //else
          //  forceUpdate()
    }

    //Metodos asociados a los archivos del usuario

    const getDataPageArchivos = () => {

        var jsonData = JSON.stringify(id_usuario);

        fetch('api/Data/GetMisArchivos', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res => {
            setdataArchivos(res);
            setloadingArchivos(false);
        }).catch(error => {
            setdataArchivos(null);
            setloadingArchivos(true);
        });
    }

    const getDataVacioArchivo = () => {

        var jsonData = JSON.stringify(datausuario.id_Usuario);

        fetch('api/Data/GetArchivoVacio', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(data => {
            setdataeditandoArchivo(data);
            setstatePageArchivos(DataStatePage.dsInsert);
            
        }).catch(error => {
            setdataeditandoArchivo(null);
        });
    }

    const grabarDataPageArchivos = (event) => {

        //Obtengo los datos
        let formulario = document.getElementById('formarchivo');
        let formData = new FormData(formulario);
        //const data = new FormData(refs.form);

        fetch('api/Data/GrabarMiArchivo', {
            method: 'POST',
            body: formData,

        }).then(response => response.json()).then(res => {

            let dataArchivosfinal = dataArchivos;

            if (dataArchivosfinal == null)
                dataArchivosfinal = [];

            if (indexeditandoArchivo == -1) {

                var array = [...dataArchivosfinal];
                array.push(res);
                setdataArchivos(array);
            }
            else {
                var array = [...dataArchivosfinal];
                array[indexeditandoArchivo] = res;
                setdataArchivos(array);
            }

            setdataeditandoArchivo(null);
            setindexeditandoArchivo(null);
            setstatePageArchivos(DataStatePage.dsSearch);
            
            setalert(PopUpResult.OK);

        }).catch(error => {
            setalert(PopUpResult.KO);
        });
    }

    const nuevoDataPageArchivo = () => {

        getDataVacioArchivo();
        setindexeditandoArchivo(-1);
    }

    const cancelarDataPageArchivos = () => {
        setdataeditandoArchivo(null);
        setindexeditandoArchivo(null);
        setstatePageArchivos(DataStatePage.dsSearch);
    }

    //Metodos asociados a los archivos del usuario

    const getDataPageReservas = (id_usu, filtrores, filtrofran, filtroest) => {

        var jsonData = JSON.stringify({ id_usuario: id_usu, visualizareserva: filtrores, franja: filtrofran, estado: filtroest });

        fetch('api/Data/GetMisReserva', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res => {
            setdataReservas(res);
            setloadingRservas(false);
        }).catch(error => {
            setdataReservas(null);
            setloadingRservas(true);            
        });
    }

    const onClickBuscarReservas = () => {

        let SuperUsuario = idRol == Roles.SuperUsuario || idRol == Roles.Administrador;

        //Por defecto ponemos los de un usuario
        let finalvisua =  "1";
        let finalfranja = 0
        let finalestado = EstadoReserva.Confirmada;
        
        if (SuperUsuario)
        {
            let visua = document.getElementById('visualizareserva');
            let franja = document.getElementById('franja');
            let estado = document.getElementById('estado');

            finalvisua = visua != null && visua.value != null ? visua.value : "1";
            finalfranja = franja != null && franja.value != null ? franja.value : 0
            finalestado = estado != null && estado.value != null ? estado.value : EstadoReserva.Confirmada
        }        

        setfiltroreserva(finalvisua);
        setfiltrofranja(finalfranja);
        setfiltroestado(finalestado);

        //LLamo a montar los relojes de realizar de nuevo la busqueda
        setloadingRservas(false);

        //LLamamos a obtener los datos de la pagina
        getDataPageReservas(id_usuario, finalvisua, finalfranja, finalestado );
    }
    
    const onClickImprimirReservas = () =>
    {
        let visua = document.getElementById('visualizareserva');
        let franja = document.getElementById('franja');

        let visuafin = visua != null && visua.value != null ? visua.value : "1";
        let franjafin = franja != null && franja.value != null ? franja.value : 0;

        var dataFinalPrint = { id_usuario: id_usuario, visualizareserva: visuafin, franja: franjafin };

        ImprimirListado(ModoReport.Preview, "ListadoReserva", dataFinalPrint, "api/DataListados/GetListadoReservas", callbackEnvioListadoMail);
    }

    const callbackEnvioListadoMail = (data) => {

        if (data != null) {

        }
    }

    //METODO SOBRE EL GRID  DE ACCESO  A OFICINAS
    const editGridDataPageOficina = (valor, index) => {

        if (valor.modoAreaPoi != ModoAreaPoi.Total) {
            setdataeditandoOficina(valor);
            indexeditandoOficina(index);

            var jsonData = JSON.stringify(valor.id_Oficina);

            if (valor.modoAreaPoi == ModoAreaPoi.ModoArea) {

                fetch('api/Data/GetAreasOficina', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: jsonData

                }).then(response => response.json()).then(res => {

                    let resareas = res.map(x => {
                        let val =
                        {
                            ...x,
                            valor: x.id_Area,
                            name: x.cod_Area
                        };

                        return val;

                    });

                    setareas(resareas);

                }).catch(error => {
                    setareas(null);                    
                });
            }
            else {

                fetch('api/Data/GetPoisOficina', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: jsonData

                }).then(response => response.json()).then(res => {

                    let respois = res.map(x => {
                        let val =
                        {
                            ...x,
                            valor: x.id_Poi,
                            name: x.title
                        };

                        return val;

                    });

                    setpois(respois);

                }).catch(error => {
                    setpois(null);
                });
            }


            var jsonData = JSON.stringify(valor.id_UsuarioOV);

            fetch('api/Data/GetAccesoPoisAreas', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {

                setdataAccesosAreasPois(res);
                setstatePageOficina(DataStatePage.dsEdit);
                setloadingAccesosAreasPois(false);

            }).catch(error => {
                setdataAccesosAreasPois([]);                
                setloadingAccesosAreasPois(true);                
            });


            setstatePageOficina(DataStatePage.dsEdit);
        }
    }

    const deleteGridDataPageOficina = (valor, index) => {


        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_UsuarioOV);

            fetch('api/Data/EliminarAccesoOficina', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res)
                {
                    //Si todo salie correcto limpio los valores de edicion
                    setdataeditandoOficina( valor);
                    setindexeditandoOficina(index);

                    if (dataoficinas != null) {
                        var array = [...dataoficinas]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        setdataoficinas(array);
                        setalert(PopUpResult.OK);
                    }                   
                }
            }).catch(error => {

            });
        }
    }

    //METODO SOBRE ACCESO AREAS POIS

    const grabarDataAccesosAreasPois = (event) => {

        let formulario = document.getElementById('formaaccesopoisareas');
        let data = new FormData(formulario);       

        fetch('api/Data/GrabarAccesoPoisAreas', {
            method: 'POST',
            body: data,

        }).then(response => response.json()).then(res => {

            if (res != null) {
                if (res.modoAreaPoi == ModoAreaPoi.ModoArea) {
                    if (areas != null) {
                        var item = areas.find(x => x.id_Area == res.id_PoiArea);

                        if (item != null)
                            res.nomAreaPoi = item.cod_Area;
                    }
                }
                else if (res.modoAreaPoi == ModoAreaPoi.ModoPoi) {
                    if (pois != null) {
                        var item = pois.find(x => x.id_Poi == res.id_PoiArea);

                        if (item != null)
                            res.nomAreaPoi = item.title;
                    }
                }

                var array = [...dataAccesosAreasPois]; // make a separate copy of the array

                //a�ado el valor
                array.push(res);

                //Modificao el estado de data para que refresque la pantalla
                setdataAccesosAreasPois(array);
            }
        }).catch(error => {
            //setState({ submitted: true, error: 2 });
        });
    }

    const deleteGridDataAccesosAreasPois = (valor, index) =>
    {

        if (valor != null) {
            var jsonData = JSON.stringify({ usuarioOVSeleccionado: valor.id_UsuarioOV, idPoiAreaSeleccionado: valor.id_PoiArea });

            fetch('api/Data/EliminarAccesosPoisAreas', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res) {

                    if (dataAccesosAreasPois != null) {
                        var array = [...dataAccesosAreasPois]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        //Modificao el estado de data para que refresque la pantalla
                        setdataAccesosAreasPois(array);

                        setalert(PopUpResult.OK);
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }

    }

    //METOSO SOBRE EL GRID DE ARCHIVOS
    const deleteGridDataArchivo = (valor, index) => {

        if (valor != null) {
            var jsonData = JSON.stringify(valor.id_MiArchivo);

            fetch('api/Data/EliminarMiArchivo', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                if (res) {

                    if (dataArchivos != null) {
                        var array = [...dataArchivos]; // make a separate copy of the array

                        //Elimino el de index concreto
                        array.splice(index, 1);

                        //Modificao el estado de data para que refresque la pantalla
                        setdataArchivos(array);

                        setalert(PopUpResult.OK);
                    }
                }
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }
    }

    //METOSO SOBRE EL GRID DE RESERVAS
    const deleteGridDataReservas = (valor, index) =>{

        if (valor != null)
        {
            if (EstaCancelarDisponibleReserva(valor, valor.tipoInstalacion))
            {
                var jsonData = JSON.stringify({ Id_Oficina: valor.id_Oficina, Id_Usuario: valor.id_Usuario, localizador: valor.localizador });

                fetch('api/Data/EliminarReservaLocalizador', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: jsonData

                }).then(response => response.json()).then(res => {
                    if (res)
                    {
                        setalert(PopUpResult.OK); 

                        onClickBuscarReservas();                       
                    }
                }).catch(error => {
                    setalert(PopUpResult.KO);
                });
            }
        }
    }

    const actualizarPagadaConfirmadadReserva = (valor, index) =>
    {

        if (valor != null) {
            if ((valor.estado == EstadoReserva.Cancelada || valor.estado == "Cancelada") || (valor.estado == EstadoReserva.Confirmada && valor.pagada == 1 && valor.ampliando == 1))
            {
                let ampliacionOk = (valor.estado == EstadoReserva.Confirmada && valor.pagada == 1 && valor.ampliando == 1);

                var jsonData = JSON.stringify({ Id_Oficina: valor.id_Oficina, Id_Usuario: valor.id_Usuario, localizador: valor.localizador });

                fetch(ampliacionOk ? 'api/Data/ActualizarAmpliarReservaLocalizador' : 'api/Data/ActualizarPagadaConfirmadaReservaLocalizador', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: jsonData

                }).then(response => response.json()).then(res => {

                    setalert(res ? PopUpResult.OK : PopUpResult.KO);

                    if (res)
                        onClickBuscarReservas();
                }).catch(error => {
                    setalert(PopUpResult.KO);
                });
            }
        }
    }

    const EnviarMailReserva = (valor, index) =>
    {

        if (valor != null) {
            var jsonData = JSON.stringify({ Id_Oficina: valor.id_Oficina, Id_Usuario: valor.id_Usuario, localizador: valor.localizador });

            fetch('api/Data/EnviarMailReserva', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {
                setalert(res ? PopUpResult.OK : PopUpResult.KO);
            }).catch(error => {
                setalert(PopUpResult.KO);
            });
        }
    }

    const ActualizarAsociarReservaACerradura = (valor, index) => {

        if (valor != null) 
        {
            if (valor.activaCerradura == 1 && valor.iD_Cerradura != null && valor.iD_Cerradura != "") {
                var jsonData = JSON.stringify({ Id_Oficina: valor.id_Oficina, Id_Usuario: valor.id_Usuario, localizador: valor.localizador });

                fetch('api/Data/ActualizarAsociarReservaACerradura', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: jsonData

                }).then(response => response.json()).then(res => {
                    setalert(res ? PopUpResult.OK : PopUpResult.KO);
                }).catch(error => {
                    setalert(PopUpResult.KO);
                });
            }
            else
                seterroralert("No tiene activa la cerradura la instalacion");
        }
    }
    
    const doCheckOutReservas = (reserva) =>
    {
        if (reserva != null) {
            if (EstaCheckoutDisponibleReserva(reserva, reserva.tipoInstalacion, reserva.conCheckOutHoraria)) {

                var jsonData = JSON.stringify({ Id_Oficina: reserva.id_Oficina, id_instalacion: reserva.id_Instalacion, localizador: reserva.localizador });               

                fetch('api/Data/DoCheckOutReserva', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: jsonData

                }).then(response => response.json()).then(res => {
                   /* if (res)
                        getDataPage(idofi, localizador, data);*/
                }).catch(error => {
                });
            }
        }
    }

    const othelloModalResulEliminar = (modo, result, valor) => {
        if (result == DialogOthelloResult.OK) 
            deleteGridDataReservas(stateModalEliminar);        

        setstateModalEliminar(null);
    }

    const othelloModalResulCheckOut = (modo, result, valor) => {
        if (result == DialogOthelloResult.OK)
            doCheckOutReservas(stateModalCheckOut);

        setstateModalCheckOut(null);
    }

    const othelloModalResulAmpliar = (modo, result, valor) => {
        if (result == DialogOthelloResult.OK) {
            onClickBuscarReservas();
        }

        setstateModalAmpliar(null);
    }        

    //METODOS DE RENDERIZADO DE LA PANTALLA

    //Metodos render Usuario

    function renderFormUsuario( user) {

        if (user != null) {
            return (<Grid container xs={12} mb={4}>
                <Grid item xs={12} >
                    <Grid container >
                        <Grid item xs={12} sm={12}>
                            <Grid container>
                                <Grid item xs={12} lg={12}>
                                    <OthelloTitulo titulo="Datos Mi Cuenta" />
                                </Grid>
                            </Grid>
                            <form id="formusuario" >
                                <Grid container>
                                    <input id="Id_Usuario" name="Id_Usuario" type="hidden" value={user.id_Usuario} />
                                    <Grid item xs={10} sm={4}>
                                        <OthelloEdit label="Nombre" fieldname="Nombre" currentvalue={user.nombre} />
                                    </Grid>
                                    <Grid item xs={10} sm={4}>
                                        <OthelloEdit label="Apellidos" fieldname="Apellido" currentvalue={user.apellido} />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={10} sm={4}>
                                        <OthelloEdit label="NIF/CIF" fieldname="NIF_CIF" currentvalue={user.niF_CIF} />
                                    </Grid>
                                    <Grid item xs={10} sm={4}>
                                        <OthelloEdit label="Telefono" fieldname="Telefono" currentvalue={user.telefono} />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={10} sm={4}>
                                        <OthelloEdit label="E-Mail" fieldname="EMail" currentvalue={user.eMail} readonly={user.id_Usuario != null && user.id_Usuario > 0} />
                                    </Grid>
                                    <Grid item xs={10} sm={4}>
                                        <OthelloEdit label="Usuario" fieldname="Usuario" currentvalue={user.usuario} readonly={user.id_Usuario != null && user.id_Usuario > 0} />
                                    </Grid>
                                </Grid>
                                {idRol == Roles.SuperUsuario ?
                                    <Grid container>
                                        <Grid item xs={10} sm={4}>
                                            <OthelloComboBox label='Confirmado' fieldname="Confirmado" items={OpcionSiNoChar} currentvalue={user.confirmado} />
                                        </Grid>
                                        <Grid item xs={10} sm={4}>
                                            <OthelloComboBox label='Rol' fieldname="Id_Rol" items={RolesUsuarios} currentvalue={user.id_Rol} />
                                        </Grid>
                                    </Grid> :
                                    <Grid container>
                                        <input id="Confirmado" name="Confirmado" type="hidden" value={user.confirmado} />
                                        <input id="Id_Rol" name="Id_Rol" type="hidden" value={user.id_Rol} />
                                    </Grid>
                                }
                                {user.id_Usuario > 0 ?
                                    <>
                                        <Grid container>
                                            <Grid item xs={12} >
                                                <p></p>
                                            </Grid>
                                            <Grid item xs={10} sm={4}>
                                                <Button color="facebook" onClick={grabarDataPage}>Guardar Datos</Button>
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item xs={12} lg={12}>
                                                <br /><br />
                                                <OthelloTitulo titulo="Password" />
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item xs={12} sm={3}>
                                                <OthelloEdit label="Antigua Password" fieldname="oldpass" type="password" />
                                            </Grid>
                                            <Grid item xs={12} sm={3}>
                                                <OthelloEdit label="Nueva Password" fieldname="Pass" type="password" />
                                            </Grid>
                                            <Grid item xs={12} sm={3}>
                                                <OthelloEdit label="Repetir Password" fieldname="Pass2" type="password" />
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item xs={10} >
                                                <p></p>
                                            </Grid>
                                            <Grid item xs={10} sm={4}>
                                                <Button color="facebook" onClick={grabarPassDataPage}>Guardar Password</Button>
                                            </Grid>
                                        </Grid>
                                    </>
                                    :
                                    <>
                                        <Grid container>
                                            <Grid item xs={12} sm={3}>
                                                <OthelloEdit label="Password" fieldname="Pass" type="password" />
                                            </Grid>
                                            <Grid item xs={12} sm={3}>
                                                <OthelloEdit label="Repetir Password" fieldname="Pass2" type="password" />
                                            </Grid>
                                        </Grid>
                                        <Grid container>
                                            <Grid item xs={12} >
                                                <p></p>
                                            </Grid>
                                            <Grid item xs={10} sm={4}>
                                                <Button color="facebook" onClick={grabarDataPage}>Guardar Datos</Button>
                                            </Grid>
                                        </Grid>
                                    </>
                                }
                            </form>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            );
        }
        else
            return "";
    }

    function renderActivacionCliente( user) {

        return (<Grid container xs={12}>
            <Grid item xs={12} >
                <Grid container >
                    <Grid item xs={12} sm={12} >
                        <Grid container>
                            <Grid item xs={12} lg={12}>
                                <OthelloTitulo titulo="Activacion Cliente" />
                            </Grid>
                        </Grid>
                        <form id="formactivacion" >
                            <input id="Id_Usuario" name="Id_Usuario" type="hidden" value={user.id_Usuario} />
                            <Grid container>
                                <Grid item xs={10} sm={4}>
                                    <OthelloEdit label="Codigo" fieldname="Codigo" currentvalue="" />
                                </Grid>
                            </Grid>
                            <Grid container>
                                <Grid item xs={10} sm={4}>
                                    <Button color="facebook" onClick={actualizarCodigoCliente}>Finalizar</Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
        );
    }

    //Metodos render de acceso a oficinas del usuario

    function renderOpcionesAccesosAreasPois( acceso, accesosAreasPois) {

        let busquedaAccesos = renderSearchAccesosAreasPois( accesosAreasPois);

        //let edicionOficinas = statePageOficina == DataStatePage.dsEdit || statePageOficina == DataStatePage.dsInsert ? renderInsertEditOficinas( dataeditandoOficina) : "";

        return (
            <Card style={{ backgroundColor: '#709e86' }}>
                <div color="success" icon>
                    <div color="success">
                        <SettingsRemote />
                    </div>
                    <h4>Accesos Definidos</h4>
                </div>
                <div style={{ backgroundColor: '#FFFFFF' }}>
                    <form id="formsaccesos" >
                        <Grid container xs={12}>
                            <input id="Id_UsuarioOV" name="Id_UsuarioOV" type="hidden" value={acceso.id_UsuarioOV} />
                            <input id="ModoAreaPoi" name="ModoAreaPoi" type="hidden" value={acceso.modoAreaPoi} />
                            <Grid item xs={12} sm={6} >
                                {acceso.modoAreaPoi == ModoAreaPoi.ModoArea ?
                                    <OthelloComboBox label='Area' fieldname="id_PoiArea" items={areas} /> :
                                    <OthelloComboBox label='Punto de Interes' fieldname="id_PoiArea" items={pois} />
                                }
                            </Grid>
                            <Grid item xs={12} sm={4}  >
                                <Button color="success" onClick={grabarDataAccesosAreasPois}>Guardar</Button>
                            </Grid>
                        </Grid>
                    </form>
                    <Grid container xs={12}>
                        <Grid item xs={12} >
                            {busquedaAccesos}
                        </Grid>
                    </Grid>
                </div >
            </Card >
        );
    }

    function renderSearchAccesosAreasPois( accesos) {

        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = ["Accesos"];
        let valoreshow = ["nomAreaPoi"];

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={accesos} onDelete={deleteGridDataAccesosAreasPois} permitefiltrar={true} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={5} />);
    }

    function renderOpcionesOficinas( oficinas) {
        let busquedaOficinas = renderSearchOficinas( oficinas);

        let edicionOficinas = statePageOficina == DataStatePage.dsEdit || statePageOficina == DataStatePage.dsInsert ? renderInsertEditOficinas( dataeditandoOficina) : "";

        //#99d9b7
        return (<div style={{ backgroundColor: '#ffffff', padding: '10px', marginBottom: '10px' }}>
            <Grid container xs={12}>
                <Grid item xs={12} >
                    {edicionOficinas}
                </Grid>
                <Grid item xs={12} lg={12}>        
                    <OthelloTitulo titulo="Mis Accesos" marginBottom={1}/>
                </Grid>
                <Grid item xs={12} >
                    <OthelloBotonera statePage={statePageOficina} onNuevo={nuevoDataPageOficina} forzarnuevo={true} />
                </Grid>
                <Grid item xs={12} >
                    {busquedaOficinas}
                </Grid>
            </Grid>
        </div>
        );
    }

    function renderSearchOficinas( oficinas) {
        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = ["Oficina", "Tipo Acceso", "Gestion Reservas", "Gestion Encuestas"];
        let valoreshow = ["nomOficina", "modoAreaPoi", "gestionReservas", "gestionEncuestas"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "modoAreaPoi", items: ModoAreasPoi });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "gestionReservas", items: OpcionSiNo });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "gestionEncuestas", items: OpcionSiNo });

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={oficinas} datasourcefields={datasourceFields} onEdit={editGridDataPageOficina} onDelete={deleteGridDataPageOficina} permitefiltrar={true} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={10} />);
    }

    function renderInsertEditOficinas(acceso)
    {
        if (acceso != null) {
            let Nombre = acceso != null && acceso.id_UsuarioOV > 0 ? "Editar Acceso " + acceso.nomOficina : "Nuevo Acceso";

            //Si estamos editando ponemos laopcion de ver sus acceso y la opcion de grabarlos        
            let accesosAreasPois = acceso.id_UsuarioOV > 0 ? renderOpcionesAccesosAreasPois(acceso, dataAccesosAreasPois) : "";

            return (
                <OthelloTituloPanelData icon="dns" titulo={Nombre} margentop={2} margenboton={2}>
                    <div style={{ backgroundColor: '#FFFFFF' }}>
                        {
                            <Grid container xs={12}>
                                <Grid item xs={12} >
                                    {
                                        acceso != null && acceso.id_UsuarioOV > 0 ? <Button color="facebook" onClick={cancelarDataPageOficina}>Volver</Button> :
                                            <OthelloBotonera statePage={statePageOficina} onGrabar={grabarDataPageOficina} onCancel={cancelarDataPageOficina} />
                                    }
                                </Grid>
                            </Grid>
                        }
                        <form id="formaccesoficina" >
                            <Grid container xs={12}>
                                <input id="Id_UsuarioOV" name="Id_UsuarioOV" type="hidden" value={acceso.id_UsuarioOV} />
                                <input id="Id_Usuario" name="Id_Usuario" type="hidden" value={acceso.id_Usuario} />
                                <input id="nomOficina" name="nomOficina" type="hidden" value={acceso.nomOficina} />
                                <Grid item xs={12} sm={3}>
                                    <OthelloComboBox label='Oficina' fieldname="id_Oficina" items={oficinas} currentvalue={acceso.id_Oficina} disabled={acceso.id_UsuarioOV > 0} />
                                </Grid>
                                <Grid item xs={10} sm={3}>
                                    <OthelloComboBox label='Tipo Acceso' fieldname="ModoAreaPoi" items={ModoAreasPoi} currentvalue={acceso.modoAreaPoi} disabled={acceso.id_UsuarioOV > 0} />
                                </Grid>
                                <Grid item xs={10} sm={2}>
                                    <OthelloComboBox label='Gestion Reservas' fieldname="GestionReservas" items={OpcionSiNo} currentvalue={acceso.gestionReservas} disabled={acceso.id_UsuarioOV > 0} />
                                </Grid>
                                <Grid item xs={10} sm={2}>
                                    <OthelloComboBox label='Gestion Encuestas' fieldname="GestionEncuestas" items={OpcionSiNo} currentvalue={acceso.gestionEncuestas} disabled={acceso.id_UsuarioOV > 0} />
                                </Grid>
                            </Grid>
                        </form>
                        <Grid container xs={12}>
                            <Grid item xs={12} >
                                {accesosAreasPois}
                            </Grid>
                        </Grid>
                    </div >
                </OthelloTituloPanelData>
            );
        }
        else
            return "";
    }

    //Render acceso a archivos del usuario
    function renderOpcionesArchivos(archivos)
    {
        let busquedaArchivos = renderSearchArchivos( archivos);

        let edicionArchivos = statePageArchivos == DataStatePage.dsEdit || statePageArchivos == DataStatePage.dsInsert ? renderInsertEditArchivo( dataeditandoArchivo) : "";

        //#99d9b7
        return (<div style={{ backgroundColor: '#ffffff', padding: '10px', marginBottom: '10px' }}>
            <Grid container xs={12}>
                <Grid item xs={12} >
                    {edicionArchivos}
                </Grid>
                <Grid item xs={12} >
                    <Grid container>
                        <Grid item xs={12} lg={12}>
                            <OthelloTitulo titulo="Mis Documentos" marginBottom={1}/>
                        </Grid>
                    </Grid>
                </Grid>
                {
                    idRol == Roles.SuperUsuario || idRol == Roles.Administrador ?
                        <Grid item xs={12} >
                            <OthelloBotonera statePage={statePageArchivos} onNuevo={nuevoDataPageArchivo} forzarnuevo={true} />
                        </Grid> : ""
                }
                <Grid item xs={12} >
                    {busquedaArchivos}
                </Grid>
            </Grid>
        </div>
        );
    }

    function renderSearchArchivos( datos) {
        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = ["", "Descripcion"];

        let valoreshow = ["btruta", "descripcion"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloButton, fieldname: "btruta", icon: Visibility, onclick: onclickColumna });

        let deleteEvento = idRol == Roles.SuperUsuario || idRol == Roles.Administrador ? deleteGridDataArchivo : null;

        //Creamos el grid global 
        return (<OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={datos} datasourcefields={datasourceFields} onDelete={deleteEvento} permitefiltrar={true} verpaginaciontop={false} verpaginacionbottom={true} tamanopagina={10} />);
    }

    function renderInsertEditArchivo(archivo) {

        if (archivo != null) {
            let Nombre = archivo != null && archivo.id_MiArchivo > 0 ? "Editar Archivo" : "Nuevo Archivo";

            return (<OthelloTituloPanelData icon="assignment" titulo={Nombre} margentop={2} margenboton={2}>
                <Grid container xs={12}>
                    <Grid item xs={12} >
                        <OthelloBotonera statePage={statePageArchivos} onNuevo={nuevoDataPageArchivo} onGrabar={grabarDataPageArchivos} onCancel={cancelarDataPageArchivos} />
                    </Grid>
                </Grid>
                <form id="formarchivo" >
                    <Grid container xs={12}>
                        <input id="Id_MiArchivo" name="Id_MiArchivo" type="hidden" value={archivo.id_MiArchivo} />
                        <input id="Id_Usuario" name="Id_Usuario" type="hidden" value={archivo.id_Usuario} />
                        <Grid item xs={12} sm={4}>
                            <OthelloEdit label="Nombre" fieldname="Descripcion" currentvalue={archivo.descripcion} />
                        </Grid>
                    </Grid>
                    <Grid container xs={12}>
                        <Grid item xs={12} sm={2}>
                            <br />
                            <legend>Archivo</legend>
                            <ImageUpload
                                id="ruta" name="ruta"
                                imageUrl={archivo.ruta}
                                addButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                changeButtonProps={{
                                    color: "rose",
                                    round: true
                                }}
                                removeButtonProps={{
                                    color: "danger",
                                    round: true
                                }}
                            />
                        </Grid>
                    </Grid>
                </form>
            </OthelloTituloPanelData>
            );
        }
        else
            return "";
    }

    //Render de las reservas que tiene el usuario activas

    function renderSearchReservas( datos) {
        //Generamos los valores de cada una de las lineas de grid
        let cabeceros = (idRol == Roles.SuperUsuario || idRol == Roles.Administrador) ?
            ["", "", "", "", "", "", "", "Fecha", "Reserva", "Instalacion", "Tramo", "Plazas", "Precio", "Pagada", "Ampliando", "Estado", "Dato Adicional"] :
            ["", "", "", "","Fecha", "Reserva", "Instalacion", "Tramo", "Plazas", "Precio", "Pagada","Ampliando", "Estado", "Dato Adicional"];

        let valoreshow = (idRol == Roles.SuperUsuario || idRol == Roles.Administrador) ?
            ["ver", "delete", "checkout", "ampliar", "email", "pagar", "conectacerradura", "fechastring", "localizador", "instalacion", "tramo", "cantidad", "precio", "pagada", "ampliando", "estado", "numSocio"] :
            ["ver", "delete", "checkout", "ampliar", "fechastring", "localizador", "instalacion", "tramo", "cantidad", "precio", "pagada", "ampliando", "estado", "numSocio"];

        let datasourceFields = [];
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloButton, fieldname: "ver", icon: Visibility, onclick: onclickColumna });

        if (idRol == Roles.SuperUsuario || idRol == Roles.Administrador) {
            datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloButton, fieldname: "pagar", icon: Payment, onclick: onclickColumna, color: "dark" });
            datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloButton, fieldname: "email", icon: Email, onclick: onclickColumna, color: "dark" });
            datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloButton, fieldname: "conectacerradura", icon: Key, onclick: onclickColumna, color: "success" });
        }

        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloButton, fieldname: "delete", icon: Close, color: "error", onclick: onclickColumna });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloButton, fieldname: "checkout", icon: DoorOpen, color: "info",  onclick: onclickColumna });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloButton, fieldname: "ampliar", icon: Add, color: "info", onclick: onclickColumna });        
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "estado", items: EstadosReserva });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "pagada", items: OpcionSiNoEntero });
        datasourceFields.push({ tipofield: TipoOthelloFieldGrid.OthelloComboBox, fieldname: "ampliando", items: OpcionSiNoEntero });

        //Creamos el grid global 

        //<div style={{ width: 140, marginLeft: 25, marginRight: 5 }}>
        //    <OthelloComboBox labelliteral="_estado" fieldname="filtro" items={EstadosOthelloPay} currentvalue={datosbusqueda != null ? datosbusqueda.estado : ''} onChange={OnChangeComboFiltro} />
        //</div>
        return (<div>
            <Grid container>
                <Grid item xs={12} lg={12}>
                    <OthelloTitulo titulo="Mis Reservas" />
                </Grid>
            </Grid>
            <OthelloTituloPanelData tituloliteral="Leyenda Opciones" margenboton={4}>
                <Grid container>
                    <Grid item xs={4} sm={2} lg={1} >
                        <Button circular={true} color="light" size="small"><Visibility /></Button> Ver
                    </Grid>
                    <Grid item xs={4} sm={2} lg={1} >
                        <Button circular={true} color="error" size="small"><Close /></Button> Cancelar
                    </Grid>
                    <Grid item xs={4} sm={2} lg={1} >
                        <Button circular={true} color="info" size="small"><DoorOpen /></Button> CheckOut
                    </Grid>
                    <Grid item xs={4} sm={2} lg={1} >
                        <Button circular={true} color="info" size="small"><Add /></Button> Ampliar
                    </Grid>                   
                    {idRol == Roles.SuperUsuario || idRol == Roles.Administrador ?
                        <>
                            <Grid item xs={4} sm={2} lg={1} >
                                <Button circular={true} color="dark" size="small"><Email /></Button> EMail
                            </Grid> 
                            <Grid item xs={4} sm={3} lg={2} >
                                <Button circular={true} color="dark" size="small"><Payment /></Button> Pagada o Ampliada Auto
                            </Grid>                                                       
                            <Grid item xs={4} sm={3} lg={2} >
                                    <Button circular={true} color="success" size="small"><Key /></Button> Conectar Cerradura
                            </Grid>
                        </> : ""}
                    
                </Grid>
            </OthelloTituloPanelData>
            <Grid container p={2}>
                {idRol == Roles.SuperUsuario || idRol == Roles.Administrador ?
                    <Grid item xs={6} sm={1}>
                        <OthelloComboBox label='Reservas' fieldname="visualizareserva" items={FiltroVerReservas} currentvalue={filtroreserva} />
                    </Grid> : <input id="visualizareserva" name="visualizareserva" type="hidden" value={filtroreserva} />}
                {idRol == Roles.SuperUsuario || idRol == Roles.Administrador ?
                    <Grid item xs={6} sm={1}>
                        <OthelloComboBox label='Franja' fieldname="franja" items={OpcionVisibilidadReservas} currentvalue={filtrofranja} />
                    </Grid> : <input id="franja" name="franja" type="hidden" value={0} />}
                {idRol == Roles.SuperUsuario || idRol == Roles.Administrador ?
                    <Grid item xs={6} sm={1}>
                        <OthelloComboBox label='Estado' fieldname="estado" items={EstadosReserva} currentvalue={filtroestado} />
                    </Grid> : <input id="franja" name="franja" type="hidden" value={0} />}
                <Grid item>
                    <Button color="default" size="sm" onClick={onClickBuscarReservas} >Buscar</Button>
                </Grid>
                {idRol == Roles.SuperUsuario || idRol == Roles.Administrador ?
                    <Grid item xs={6} sm={1}>
                        <Button color="linkedin" size="sm" onClick={onClickImprimirReservas} >Imprimir</Button>
                    </Grid> : ""}
            </Grid>
            <Divider/>
            <Grid container m={2} >
                <Grid item xs={12} >
                    <OthelloGrid datacabeceros={cabeceros} datashow={valoreshow} datasource={datos} datasourcefields={datasourceFields} permitefiltrar={true} verpaginaciontop={false}
                        verpaginacionbottom={true} tamanopagina={10} />
                </Grid>
            </Grid></div>);
    }

    function renderModalMasInfoReserva(item) {
        if (item != null) {
            return (<OthelloModalBase titulo="Reserva" modo={ModoModal.SinDefinir} open={stateModal} onCloseResulModal={othelloModalResul} botones={MessageOthelloBoxButtons.OK} >
                <TicketReservaInfo reserva={item} infouso={item.infouso} modoexterno={false} id_Rol={idRol} desdeticketreserva={false} />     
            </OthelloModalBase>)
        }
        else
            return "";        
    }

    function renderModalAmpliarReserva(item) {
        return (<OthelloModalBase titulo="Ampliar Reserva" open={true} onCloseResulModal={othelloModalResulAmpliar} botones={MessageOthelloBoxButtons.None} maxWidth="xl">
            <ReservarAmpliar instalacion={null} reserva={item != null ? item : null} onModalResulAmpliar={othelloModalResulAmpliar} desdeticketreserva={false} modoexterno={false} />
        </OthelloModalBase>);
    }

 
    let modal = "";
     
    if (stateModal != DataStateModal.dsClosed && modomodal == "ver")
        modal = renderModalMasInfoReserva( itemmodal);

    let MiPerfilFormulario = loading ? <p><CircularProgress color="secondary" /></p> : renderFormUsuario( datausuario);

    let MisAccesos = loadingOficinas ? <p><CircularProgress  color="secondary" /></p> : renderOpcionesOficinas( dataoficinas)

    let MisReservas = loadingRservas ? <p><CircularProgress  color="secondary" /></p> : renderSearchReservas( dataReservas)

    let ReservarCliente = datausuario != null && datausuario.id_Usuario > 0 ? <Reservar user={datausuario} onResultReserva={OnResultReserva} /> : ""

    let MisArchivos = loadingArchivos ? <p><CircularProgress  color="secondary" /></p> : renderOpcionesArchivos( dataArchivos)

    let ActivacionCliente = datausuario != null && datausuario.id_Usuario > 0 ? renderActivacionCliente( datausuario) : ""

    let alerta = alert != null ? <OthelloPopUpResult titulo={erroralert} alert={alert}  onClosePopUpResult={onClosePopUpResult} /> : "";

    let NombreUsuario = datausuario != null && datausuario.id_Usuario > 0 ? datausuario.nombre + " " + datausuario.apellido : "Nuevo Usuario";

    let modalEliminarReserca = "";

    //Si el estado del modal es distinto de cerrado
    if (stateModalEliminar != null)
        modalEliminarReserca = <OthelloMensaje tituloliteral="ATMovilidad" descrip="Estas seguro de cancelar la reserva?" modo={ModoModal.SinDefinir} open={true} onCloseResulModal={othelloModalResulEliminar} botones={MessageOthelloBoxButtons.OKCancel} />

    let modalCheckoutReserca = "";

    //Si el estado del modal es distinto de cerrado
    if (stateModalCheckOut != null)
        modalCheckoutReserca = <OthelloMensaje tituloliteral="ATMovilidad" descrip="Estas seguro de hacer el Check-Out la reserva?" modo={ModoModal.SinDefinir} open={true} onCloseResulModal={othelloModalResulCheckOut} botones={MessageOthelloBoxButtons.OKCancel} />

    let modalAmpliarReserca = "";

   
    //Si el estado del modal es distinto de cerrado
    if (stateModalAmpliar != null)
        modalAmpliarReserca = renderModalAmpliarReserva(stateModalAmpliar);

    let tabs = [];

    // if (datausuario != null && datausuario.id_Rol != Roles.UsuarioApp)
    if (idRol == Roles.SuperUsuario || (datausuario != null && datausuario.id_Usuario > 0 && datausuario.id_Usuario == idUser)) {
        tabs.push(
            {
                tabButton: "Mi Perfil",
                tabIcon: Face,
                tabContent: (MiPerfilFormulario)
            });
    }

    if (datausuario != null && datausuario.id_Usuario > 0) {   //Si el usuario conectado es superusuario pued modificar los accesos de cualquiera
        if (idRol == Roles.SuperUsuario && !loginmodoreserva && !loginapps) {
            tabs.push(
                {
                    tabButton: "Accesos",
                    tabIcon: Dns,
                    tabContent: (MisAccesos)
                });
        }

        if (loginmodoreserva) {
            tabs.push(
                {
                    tabButton: "Mis Reservas",
                    tabIcon: Assignment,
                    tabContent: (MisReservas)
                });

            tabs.push(
                {
                    tabButton: "Reservar",
                    tabIcon: Activacion,
                    tabContent: (ReservarCliente)
                });

        }
        else {
            tabs.push(
                {
                    tabButton: "Documentos",
                    tabIcon: Assignment,
                    tabContent: (MisArchivos)
                });

            tabs.push(
                {
                    tabButton: "Activacion",
                    tabIcon: Activacion,
                    tabContent: (ActivacionCliente)
                });
        }
    }
    
    return (
        <div>
            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    {alerta}
                    {modalEliminarReserca}
                    {modalCheckoutReserca}
                    {modalAmpliarReserca}
                    {modal}
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                    <OthelloTituloPanelData tituloliteral="_miperfil" margentop={2}>
                        <Grid container>
                            <Grid item xs={12}>
                                {NombreUsuario}
                            </Grid>
                        </Grid>
                    </OthelloTituloPanelData>
                </Grid>
            </Grid>
            <Grid container >
                <Grid item xs={12} sm={12}>
                    <Card>
                        <div style={{ backgroundColor: '#FFFFFF' }}>
                            <NavPills
                                color="info"
                                tabs={tabs}
                                active={loginmodoreserva ? 2 : (loginapps ? 1 : 0)}
                            />
                        </div>
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
}